export default __webpack_public_path__ + "static/eng-4-ceba65128a2bc346e8fc177e2ffe9a13.jpg";